import { useReactiveVar } from '@apollo/client';
import { isMobileVar } from 'shared/domains/apollo/utils/cacheVars';
const useMobile = () => useReactiveVar(isMobileVar);
export default useMobile;
